var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 107,
    viewBox: "0 0 64 107",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5553 66.2514L37.3322 86.9404L37.3322 5.67735C37.3322 4.26315 36.7704 2.90688 35.7705 1.90689C34.7705 0.906906 33.4142 0.345123 32 0.345123C30.5858 0.345123 29.2295 0.906906 28.2296 1.90689C27.2296 2.90688 26.6678 4.26315 26.6678 5.67735L26.6678 86.9404L9.44471 66.2514C8.53963 65.1625 7.23904 64.4777 5.82906 64.3477C4.41908 64.2177 3.01521 64.6531 1.92628 65.5582C0.837349 66.4633 0.152557 67.7639 0.0225601 69.1739C-0.107437 70.5838 0.327999 71.9877 1.23308 73.0766L27.8942 105.07C28.3945 105.674 29.0219 106.16 29.7316 106.493C30.4413 106.827 31.2158 107 32 107C32.7842 107 33.5587 106.827 34.2684 106.493C34.9781 106.16 35.6055 105.674 36.1058 105.07L62.7669 73.0766C63.2151 72.5375 63.5526 71.9153 63.7603 71.2456C63.968 70.576 64.0418 69.872 63.9775 69.1739C63.8475 67.7639 63.1627 66.4633 62.0737 65.5582C60.9848 64.6531 59.5809 64.2177 58.171 64.3477C56.761 64.4777 55.4604 65.1625 54.5553 66.2514Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.72769e831ecf79f7037265c9adc74d46.svg";
export { ForwardRef as ReactComponent };